import axios from 'axios';

const responseIsJson = (res) => {
  if (typeof res.data === 'object') {
    return true;
  } else {
    console.warn(`getProductCollection ERROR: ${res?.config?.url} returned invalid JSON.`);
    return false;
  }
};

async function getProductCollections(collections) {
  try {
    const axiosGets = collections
    .filter(collection => collection.includes('us-west-2') === false)
    .map(collection => `https://cdn-nocache.facecake.com/p/${collection}/products.json`);
    const getAll = async (collection) => {
      const requests = collection.map(req => {
        return axios.get(req).catch(() => null);
      })
      return axios.all(requests);
    }
    const responses = await getAll(axiosGets);
    const productCollections = responses
    .map((res, i) => ({collection: collections[i], ...res })) // add collection name to response
    .filter(res => res?.status === 200 && responseIsJson(res))  // filter out bad JSON
    .map(res => ({[res.collection]: res.data}));  // reformat response
    return productCollections;
  } catch (err) {
    console.warn(err);
  }
}

export default getProductCollections;